import { QuotePrice } from '@brenger/api-client';
import React from 'react';
import { getIsExcludingVat } from '../../../../modules/User/ducks';
import { useTypedSelector } from '../../../../hooks';
import { priceAsString } from '../../../../utils/price';

export interface SimplePriceProps {
  price?: QuotePrice | null;
  addPlusMinusIndicator?: boolean;
  withDoubleZeroes?: boolean;
}

export const SimplePrice = ({
  price,
  addPlusMinusIndicator = true,
  withDoubleZeroes = false,
}: SimplePriceProps): JSX.Element | null => {
  const isExclVat = useTypedSelector(getIsExcludingVat);
  const amount = price?.[isExclVat ? 'excl_vat' : 'incl_vat'];
  if (!amount) return null;
  return <>{priceAsString({ price: amount, addPlusMinusIndicator, withDoubleZeroes })}</>;
};
